import { FileOutlined, FileProtectOutlined } from '@ant-design/icons';
import { useDeleteFrontRichiesteIdModuliIdSezioniIdFileCodice } from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { ButtonDeleteConfirm } from '@framework/ui/components/button/ButtonDeleteConfirm.tsx';
import { FileRow } from '@framework/ui/components/file/FileRow.tsx';
import { message, type UploadFile } from 'antd';
import { WidgetDownloadButton } from '../download/WidgetDownloadButton.tsx';

export interface IUploadedFileRowProps {
  file: UploadFile | undefined;
  submissionId: string | null | undefined;
  submissionModuleId: string | null | undefined;
  sectionId: string | null | undefined;
  readonly?: boolean;
  code: string;

  reset: () => void;

  isFileSigned?: boolean;
  omissis?: boolean;
}

export function UploadedFileRow(props: IUploadedFileRowProps) {
  const {
    file,
    submissionId,
    submissionModuleId,
    sectionId,
    code,
    reset,
    readonly,
    isFileSigned,
    omissis,
  } = props;

  const remove = useDeleteFrontRichiesteIdModuliIdSezioniIdFileCodice();
  const areIdsDefined = !!submissionId && !!submissionModuleId && !!sectionId;

  if (!file) return null;

  return (
    <FileRow
      file={file}
      icon={
        isFileSigned ? (
          <FileProtectOutlined aria-hidden />
        ) : (
          <FileOutlined aria-hidden />
        )
      }
      downloadButton={
        areIdsDefined ? (
          <WidgetDownloadButton
            submissionId={submissionId}
            submissionModuleId={submissionModuleId}
            sectionId={sectionId}
            code={code}
            id={file.uid}
            filename={file.name}
            omissis={omissis}
          />
        ) : undefined
      }
      deleteButton={
        !readonly && areIdsDefined ? (
          <ButtonDeleteConfirm
            title="Sei sicuro di voler rimuovere il file?"
            buttonDanger
            iconOnlyButton
            size="small"
            loading={remove.isLoading}
            onConfirm={() => {
              remove
                .mutateAsync({
                  id: submissionId,
                  codice: code,
                  idRichiestaModulo: submissionModuleId,
                  idSezione: sectionId,
                  params: {
                    omissis,
                    idAllegato: file.uid ?? undefined,
                  },
                })
                .then(() => {
                  reset();
                })
                .catch((e: any) => {
                  if (e.response?.status === 404) {
                    // Il file non è stato trovato, possiamo dunque rimuoverlo
                    // dalla lista dei file caricati
                    console.log(
                      'File non trovato, rimuovendo dalla lista dei file caricati',
                    );
                    reset();
                    return;
                  }
                  console.error('[RemoveFile] Error after API', { error: e });
                  message.error('Errore durante la rimozione del file');
                });
            }}
          />
        ) : undefined
      }
    />
  );
}
